import _clone from 'lodash/clone';
import _cloneDeep from 'lodash/cloneDeep';
import template from 'es6-template-strings';
import React, { Component, PropTypes } from 'react';
import connect from 'connect-alt';
import translate from '../../utils/translate';

const LocationListMode = {
  add: 'add',
  view: 'view',
  edit: 'edit'
};

class LocationList extends Component {

  static propTypes = {
    mode: PropTypes.string,
    title: PropTypes.string,
    locations: PropTypes.array.isRequired
  };

  static contextTypes = {
    flux: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired
  };

  static defaultProps = {
    mode: LocationListMode.view
  };

  constructor(props) {
    const { locations } = props;
    super(props);
    this.state = {
      locations: _cloneDeep(locations)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.locations) {
      this.setState({
        locations: _cloneDeep(nextProps.locations)
      });
    }
  }

  _handleAddClick(location) {
    const { flux } = this.context;
    const locations = _clone(flux.getStore('Location').getState().userLocations) || [];

    locations.splice(0, 0, location);

    flux.getActions('Location').updateUserLocations(locations).then(() => {
      flux.getActions('Location').updateCurrent(location).then(() => {
        // TODO: improve
        window.location.reload();
      });
    });
  }

  _handleRemoveClick(i) {
    const { locations } = this.state;
    const copy = _cloneDeep(locations);

    copy.splice(i, 1);

    this.setState({
      locations: copy
    });
  }

  _handleCustomNameChange(i, value) {
    const { locations } = this.state;
    const copy = _cloneDeep(locations);

    copy[i].customName = value;

    this.setState({
      locations: copy
    });
  }

  _handleClick(location) {
    const { flux } = this.context;

    flux.getActions('Location').updateCurrent(location).then(() => {
      // TODO: improve
      window.location.reload();
    });
  }

  save() {
    const { flux } = this.context;
    const { locations } = this.state;

    flux.getActions('Location').updateUserLocations(locations);
  }

  render() {
    const { title, mode } = this.props;
    const { locations } = this.state;
    const {
      config: {
        appOptions: { language },
      }
    } = this.context;

    const placeHolder = translate('NICKNAME', language);
    const locationComponents = locations.map((location, i) =>
      <LocationListItem
        key={i}
        location={location}
        nickNamePlaceHolder={placeHolder}
        mode={mode}
        onClick={mode === LocationListMode.view ? () => this._handleClick(location, i) : null}
        onAddClick={mode === LocationListMode.add ? () => this._handleAddClick(location) : null}
        onRemoveClick={mode === LocationListMode.edit ? () => this._handleRemoveClick(i, location) : null}
        onCustomNameChange={mode === LocationListMode.edit ? (e) => this._handleCustomNameChange(i, e.target.value) : null}
        />
      );

    return (
      <div className="LocationList">
        {title ? <div className="LocationList-title">{title}</div> : null}
        {locationComponents}
      </div>
    );
  }
}

class LocationListItem extends Component {
  static propTypes = {
    mode: PropTypes.string,
    location: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    onAddClick: PropTypes.func,
    onRemoveClick: PropTypes.func,
    onCustomNameChange: PropTypes.func,
    nickNamePlaceHolder: PropTypes.string
  };

  defaultProps = {
    mode: LocationListMode.view
  };

  render() {
    const { mode, location, onClick, onAddClick, onRemoveClick, onCustomNameChange, nickNamePlaceHolder } = this.props;
    const { customName } = location;


    let components;

    switch (mode) {
      case LocationListMode.view:
        if (customName) {
          components = [
            <div key={0} className="LocationList-Item-sub"><CityStateString location={location} /></div>,
            <div key={1} className="LocationList-Item-main">{customName}</div>
          ];
        } else {
          components = [
            <div key={0} className="LocationList-Item-main"><CityStateString location={location} /></div>
          ];
        }
        break;
      case LocationListMode.add:
        components = [
          <div key={0} className="LocationList-Item-addIcon" onClick={onAddClick} />,
          <div key={1} className="LocationList-Item-main" onClick={onAddClick}><CityStateString location={location} /></div>
        ];
        break;
      case LocationListMode.edit:
        components = [
            <div key={0} className="LocationList-Item-removeIcon" onClick={onRemoveClick} />,
            <div key={1} className="LocationList-Item-sub"><CityStateString location={location} /></div>,
            <input key={2} type="text" value={customName} onChange={onCustomNameChange} className="LocationList-nicknameInput" placeholder={nickNamePlaceHolder}/>,
        ];
        break;
      default:
        components = null;
        break;
    }

    return (
      <div className={"LocationList-Item LocationList-Item--" + mode} onClick={onClick} >
        {components}
      </div>
    );
  }
}

class CityStateString extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired
  };

  render() {
    const { location } = this.props;

    return <span className="CityStateString">{template('${city}, ${stateAbbr}', location)}</span>;
  }
}

class LocationName extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    lang: PropTypes.string
  };

  render() {
    const { location, lang } = this.props;

    return (
      <div className="LocationName">
        {location.customName ? location.customName : <CityStateString location={location} />}
        <span className="LocationName-edit">{translate('EDIT', lang)}</span>
      </div>
    );
  }
}

class LocationDropdown extends Component {
  static propTypes = {
    backgroundColor: PropTypes.string,
    customLocations: PropTypes.array.isRequired,
    stationLocations: PropTypes.array.isRequired,
    onHide: PropTypes.func,
    lang: PropTypes.string
  };

  static contextTypes = {
    flux: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const { customLocations } = props;

    this.state = {
      mode: LocationListMode.view,
      customLocations: _cloneDeep(customLocations)
    };
  }

  componentWillReceiveProps(nextProps) {
    const { customLocations } = nextProps;

    if (customLocations) {
      this.setState({
        customLocations: _cloneDeep(customLocations)
      });
    }
  }

  _handleCancelClick() {
    const { customLocations } = this.props;
    const { mode } = this.state;

    this.setState({
      customLocations: _cloneDeep(customLocations),
      mode: LocationListMode.view
    }, () => {
      if (mode === LocationListMode.view) {
        const { onHide } = this.props;
        if (onHide) {
          onHide();
        }
      }
    });
  }

  _handleEditClick() {
    this.setState({
      mode: LocationListMode.edit
    });
  }

  _handleSaveClick() {
    const { customLocations } = this.refs;

    if (customLocations) {
      customLocations.save();
    }

    this.setState({
      mode: LocationListMode.view
    });
  }

  render() {
    const { stationLocations, backgroundColor, lang } = this.props;
    const { mode, customLocations } = this.state;
    const actionButton = (mode === LocationListMode.view) ? <button className="LocationMenu-editButton" onClick={() => this._handleEditClick()}>{translate('Edit', lang)}</button> :
      <button className="LocationMenu-saveButton" onClick={() => this._handleSaveClick()}>{translate('Save', lang)}</button>;
    const customStyle = { backgroundColor };
    const customLocationsTitle = translate('Custom Locations', lang);
    const stationLocationsTitle = translate('Station Locations', lang);

    return (
      <div className="LocationMenu" style={customStyle}>
        <button className="LocationMenu-cancelButton" onClick={() => this._handleCancelClick()}>{translate('Cancel', lang)}</button>
        {customLocations.length ? actionButton : null}
        <div className="LocationMenu-container">
          {customLocations.length > 0 ?
            <LocationList ref="customLocations" title={customLocationsTitle} locations={customLocations} mode={mode} /> : null}
          {stationLocations.length > 0 ?
            <LocationList title={stationLocationsTitle} locations={stationLocations} /> : null}
        </div>
      </div>
    );
  }
}

class LocationSearchResults extends Component {
  static propTypes = {
    results: PropTypes.array,
    errorMessage: PropTypes.string,
    backgroundColor: PropTypes.string
  };

  render() {
    const { results, errorMessage, backgroundColor } = this.props;
    const customStyle = {backgroundColor};

    return (
      <div className="LocationSearchResults" style={customStyle}>
        <LocationList locations={results} mode={LocationListMode.add} />
        {errorMessage ? <div className="LocationSearchResults-error">{errorMessage}</div> : null}
      </div>
    );
  }
}

/**
 * Class representing the currently displayed weather location, available locations, and ability to search for new location.
 *
 * Dependent on feed - UNKNOWN
 */
@connect('Location')
class LocationSelector extends Component {

  static propTypes = {
    LocationStore: PropTypes.object.isRequired,
    backgroundColor: PropTypes.string
  };

  static contextTypes = {
    flux: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired
  };

  state = {
    showMenu: false,
    showSearchResults: false,
    searchValue: ''
  };

  componentDidMount() {
    const { flux } = this.context;

    flux.getActions('Location').readUserLocations();
  }

  _toggleMenuVisibility() {
    this.setState({
      showMenu: !this.state.showMenu,
      showSearchResults: false
    });
  }

  _handleSearchIconClick(event) {
    if (this.state.showSearchResults) {
      this._clearSearchResults();
      this._hideSearchResults();
    } else {
      this._handleSubmit(event);
    }
  }

  _hideMenu() {
    this.setState({
      showMenu: false
    });
  }

  _onSearchInputChange(event) {
    const value = event.target.value;

    if (/^[\d-]*$/.test(value)) {
      this.setState({
        searchValue: value
      });
    }
  }

  _showSearchResults() {
    this.setState({
      showSearchResults: true,
      showMenu: false
    });
  }

  _clearSearchResults(){
    this.setState({
      searchValue: ""
    });
  }

  _hideSearchResults() {
    const { flux } = this.context;

    flux.getActions('Location').clearSearchResults();

    this.setState({
      showSearchResults: false
    });
  }

  _handleSubmit(e) {
    const { flux } = this.context;
    const { searchValue } = this.state;

    flux.getActions('Location').search(searchValue);
    this._showSearchResults();

    e.preventDefault();
    return false;
  }

  render() {
    const {
      location,
      config: {
        appOptions: {
          language
        } = {},
        affiliate: {
          locations = []
        } = {}
      } = {},
    } = this.context;
    const { LocationStore: { userLocations, searchResults, errors: { search: error } }, backgroundColor } = this.props;
    const { showMenu, showSearchResults, searchValue } = this.state;
    let errorMessage = '';

    if (error) {
      switch (error.status) {
        case 400:
          errorMessage = translate('Nothing to find', language);
          break;
        case 404:
          errorMessage = translate('Location not found', language);
          break;
        default:
          break;
      }
    }

    return (
      <div className="LocationSelector">
        <div className="LocationSelector-headerBlock">
          <div className="LocationSelector-locationName" onClick={() => this._toggleMenuVisibility()}>
            <LocationName  location={location} lang={language} /></div>
          <form onSubmit={e => this._handleSubmit(e)} >
            <input
              className="LocationSelector-locationInput"
              type="text"
              placeholder={translate('Enter Zip Code', language)}
              value={searchValue}
              onChange={this._onSearchInputChange.bind(this)}
              onFocus={this._hideMenu.bind(this)}
            />
          </form>
          <div
            className={"LocationSelector-inputIcon LocationSelector-inputIcon" + (showSearchResults ? "--clear" : "--search")}
            onClick={this._handleSearchIconClick.bind(this)}
          />
        </div>
        {showMenu ?
          <LocationDropdown
            lang={language}
            stationLocations={locations}
            customLocations={userLocations}
            onHide={() => this._hideMenu()}
            backgroundColor={backgroundColor}
            /> : null}
        {showSearchResults ?
          <LocationSearchResults results={searchResults} errorMessage={errorMessage} backgroundColor={backgroundColor}/> : null}
      </div>
    );
  }
}

export default LocationSelector;



// WEBPACK FOOTER //
// ./app/components/weather/LocationSelector.js